import React from 'react';
import StepsProps from './StepsProps';
import Icon from '@lib/components/Icon';
import Step from './Step';

export default class StepsMobile extends React.Component<StepsProps> {
    render() {
        const { steps, currentStep, setCurrentStep } = this.props;

        return (
            <div className="steps-mobile is-mobile-only">
                {steps.map((step, index) => (
                    <div key={index} className="step-mobile">
                        <button className="step-mobile__button" type="button" onClick={() => setCurrentStep(index)}>
                            {step.headlineType ? (
                                (() => {
                                    const CustomHeadingTag = step.headlineType as keyof JSX.IntrinsicElements;
                                    return (
                                        <CustomHeadingTag className="custom-headline-type-inherit step-mobile__text">
                                            {step.headline}
                                        </CustomHeadingTag>
                                    );
                                })()
                            ) : (
                                <span className="step-mobile__text">{step.headline}</span>
                            )}
                            <span className="step-mobile__icon">
                                <Icon icon={index === currentStep ? 'minus' : 'plus'} />
                            </span>
                        </button>
                        {index === currentStep && (
                            <div className="step-mobile__content">
                                <Step content={step} />
                            </div>
                        )}
                    </div>
                ))}
            </div>
        );
    }
}
